import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { Apiconfig } from '../../core/helpers/apiConfig';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {
  blogs: any[] = [];
  apiUrl: string = environment.apiUrl;

  constructor(
    private apiService: ApiService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.getBlogs();
  }

  getBlogs() {
    this.apiService.commonApi(Apiconfig.listPage.method, Apiconfig.listPage.url, {})
      .subscribe(
        (result: any) => {
          if (result && result.length > 0) {
            // ✅ Sort blogs so "current" blog comes first
            // Copy result to prevent mutating the SSR read-only array state
            this.blogs = [...result].sort((a: any, b: any) => (b.current ? 1 : 0) - (a.current ? 1 : 0));
          } else {
            this.blogs = [];
          }
        },
        error => {
          console.error(error);
        }
      );
  }

  // ✅ Extract only <h*> tags (h1-h6) from description
  //  extractFirstHeading(content: string): SafeHtml {
  //   if (!content) return '';

  //   // Find the first <h1> to <h6> tag
  //   const match = content.match(/<h[1-6][^>]*>.*?<\/h[1-6]>/i);
  //   const firstHeading = match ? match[0] : '';

  //   return this.sanitizer.bypassSecurityTrustHtml(firstHeading);
  // }

  extractFirstHeading(content: string): SafeHtml {
    if (!content) return '';

    // Find the first heading tag (h1–h6)
    const match = content.match(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/i);

    if (!match) return '';

    // Extract only the inner text (group 1)
    const innerText = match[1].replace(/<[^>]*>/g, ''); // remove nested tags if any

    // Wrap in clean <h5>
    const cleanHeading = `<h5>${innerText}</h5>`;

    return this.sanitizer.bypassSecurityTrustHtml(cleanHeading);
  }


}
